<template>
  <div>
    <mavon-editor
      v-model="source"
      v-if="source.length > 20"
      :toolbars="toolbarsConfig"
      :editable="false"
      :subfield="false"
      ref="mavonEditor"
      defaultOpen="preview"
    />
    <el-button
      v-if="source.type != 'buyer_suggestion'"
      style="float: right; top: -5px;"
      @click="exportToPDF"
      >导出为 PDF</el-button
    >
    <el-button
      v-if="source.type != 'buyer_suggestion'"
      style="float: right; top: 5px;"
      @click="exportToDocx"
      >导出为 DOCX</el-button
    >
   
    
  </div>
</template>

<script>
import { 
  Document, 
  Packer, 
  Paragraph, 
  TextRun, 
  Table, 
  TableRow, 
  TableCell, 
  WidthType, 
  AlignmentType,
  HeadingLevel,
  BorderStyle
} from 'docx';
import { jsPDF } from 'jspdf';
import html2canvas from 'html2canvas';
import MarkdownIt from 'markdown-it';



export default {
  name: 'MarkdownViewer',
  props: {
    source: {
      type: String,
      default: ''
    },
    sanitize: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      toolbarsConfig: {
        bold: false,
        italic: false,
        header: false,
      },
      md: new MarkdownIt({
        html: true,
        linkify: true,
        typographer: true
      })
    };
  },
  methods: {
    // async exportToPDF() {
    //   const editor = this.$refs.mavonEditor;
    //   const element = editor.$el.querySelector('.v-show-content') || editor.$el;
    //   const pdf = new jsPDF('p', 'mm', 'a4');
    //   const pageWidth = pdf.internal.pageSize.getWidth();
    //   const pageHeight = pdf.internal.pageSize.getHeight();
    //   const margin = 10; // 页边距
    //   const scale = 2; // 提高清晰度

    //   const canvas = await html2canvas(element, {
    //     scale,
    //     useCORS: true,
    //     logging: true,
    //   });

    //   const imgWidth = pageWidth - margin * 2;
    //   const imgHeight = (canvas.height * imgWidth) / canvas.width;
    //   let totalHeight = imgHeight;
    //   let position = 0;
    //   let currentPage = 1;

    //   // 首頁添加图片
    //   pdf.addImage(canvas, 'PNG', margin, margin, imgWidth, imgHeight, '', 'FAST');

    //   // 计算需要添加的页数
    //   while (totalHeight > pageHeight - margin) {
    //     pdf.addPage();
    //     position = -(pageHeight - margin) * currentPage;
    //     currentPage++;
    //     // 添加后续页面的图片部分
    //     pdf.addImage(
    //       canvas,
    //       'PNG',
    //       margin,
    //       position,
    //       imgWidth,
    //       imgHeight,
    //       '',
    //       'FAST'
    //     );
    //     totalHeight -= pageHeight - margin * 2;
    //   }

    //   pdf.save('exported.pdf');
    // },
async exportToPDF() {
  const element = this.$refs.mavonEditor.$el.querySelector('.v-show-content') || this.$refs.mavonEditor.$el;
  const pdf = new jsPDF('p', 'mm', 'a4');
  const pageWidth = pdf.internal.pageSize.getWidth();
  const pageHeight = pdf.internal.pageSize.getHeight();
  const margin = 10;
  const scale = 2;
  const bufferHeight = 30;
  // 1. 计算页面对应的像素高度（html2canvas 默认 96dpi）
  const pxPerMm = 140 / 24.4;
  const pagePxHeight = (pageHeight - 2 * margin) * pxPerMm;

  // 2. 获取所有子块（这里以直接子元素为例，根据你实际内容更改）
  const children = Array.from(element.children);

  let tempContainer = document.createElement('div');
  tempContainer.style.position = 'absolute';
  tempContainer.style.top = '-9999px';
  tempContainer.style.left = '-9999px';
  tempContainer.style.width = element.offsetWidth + 'px';
  document.body.appendChild(tempContainer);

  let currentPageElements = [];
  let currentHeight = 0;
  let pageIndex = 0;

  function renderPage(elements) {
    return new Promise(async resolve => {
      tempContainer.innerHTML = '';
      elements.forEach(el => tempContainer.appendChild(el.cloneNode(true)));

      const canvas = await html2canvas(tempContainer, { scale, useCORS: true });
      const imgWidth = pageWidth - 2 * margin;
      const imgHeight = (canvas.height * imgWidth) / canvas.width;

      if (pageIndex > 0) pdf.addPage();
      pdf.addImage(canvas, 'PNG', margin, margin, imgWidth, imgHeight, undefined, 'FAST');
      pageIndex++;
      resolve();
    });
  }

  for (let i = 0; i < children.length; i++) {
    // 克隆节点测量高度
    const clone = children[i].cloneNode(true);
    tempContainer.appendChild(clone);
    const cloneHeight = tempContainer.scrollHeight;

    if (currentHeight + cloneHeight + bufferHeight > pagePxHeight) {
      // 当前页满了，先生成PDF页
      await renderPage(currentPageElements);

      // 清空本页缓存
      currentPageElements = [children[i]];
      currentHeight = cloneHeight;
      tempContainer.innerHTML = '';
    } else {
      currentPageElements.push(children[i]);
      currentHeight += cloneHeight;
      tempContainer.removeChild(clone);
    }
  }

  // 最后一页，也生成PDF
  if (currentPageElements.length > 0) {
    await renderPage(currentPageElements);
  }

  document.body.removeChild(tempContainer);
  pdf.save(`${this.sanitize}.pdf`);
},




// async exportToPDF () {
// const element = this.$refs.mavonEditor.$el.querySelector('.v-show-content') || this.$refs.mavonEditor.$el;
// const pdf = new jsPDF ('p', 'mm', 'a4');
// const pageWidth = pdf.internal.pageSize.getWidth ();
// const pageHeight = pdf.internal.pageSize.getHeight ();
// const margin = 10;
// const scale = 2; // 提高清晰度// 1. 计算页面对应的像素高度（html2canvas 默认 96dpi）
// const pxPerMm = 96 / 25.4; // 标准转换率
// const pagePxHeight = (pageHeight - 2 * margin) * pxPerMm;// 额外缓冲区，避免文本被分割
// const bufferHeight = 30; // 根据字体大小调整// 2. 获取所有子块（这里以直接子元素为例，根据你实际内容更改）
// const children = Array.from (element.children);let tempContainer = document.createElement('div');
// tempContainer.style.position = 'absolute';
// tempContainer.style.top = '-9999px';
// tempContainer.style.left = '-9999px';
// tempContainer.style.width = element.offsetWidth + 'px';
// document.body.appendChild(tempContainer);let currentPageElements = [];
// let currentHeight = 0;
// let pageIndex = 0;function renderPage(elements) {
// return new Promise(async resolve => {
// tempContainer.innerHTML = '';
// elements.forEach(el => tempContainer.appendChild(el.cloneNode(true)));// 等待 DOM 更新完成
// await new Promise (resolve => requestAnimationFrame (resolve));// 优化渲染质量
// const canvas = await html2canvas (tempContainer, {
// scale,
// useCORS: true,
// logging: false,
// letterRendering: 1,
// allowTaint: false
// });const imgWidth = pageWidth - 2 * margin;
// const imgHeight = (canvas.height * imgWidth) / canvas.width;if (pageIndex > 0) pdf.addPage();
// pdf.addImage(canvas, 'PNG', margin, margin, imgWidth, imgHeight, undefined, 'FAST');
// pageIndex++;
// resolve();
// });
// }for (let i = 0; i < children.length; i++) {
// // 克隆节点测量高度
// const clone = children [i].cloneNode (true);
// tempContainer.appendChild (clone);// 等待 DOM 更新完成
// await new Promise (resolve => requestAnimationFrame (resolve));const cloneHeight = tempContainer.scrollHeight - currentHeight;// 检查是否有足够空间
// if (currentHeight + cloneHeight + bufferHeight> pagePxHeight) {
// // 当前页满了，先生成 PDF 页
// await renderPage (currentPageElements);// 清空本页缓存
// currentPageElements = [children [i]];
// currentHeight = cloneHeight;
// tempContainer.innerHTML = '';
// } else {
// currentPageElements.push (children [i]);
// currentHeight += cloneHeight;
// tempContainer.removeChild (clone);
// }
// }// 最后一页，也生成 PDF
// if (currentPageElements.length> 0) {
// await renderPage (currentPageElements);
// }document.body.removeChild(tempContainer);
// pdf.save(`${this.sanitize}.pdf`);
// },
//     exportToDocx() {  
//   const md = this.md;  
//   const tokens = md.parse(this.source, {});  
//   const docElements = [];  
//   let currentTable = null;  
//   let currentRow = [];  
//   let inTable = false;  

//   tokens.forEach((token, index) => {  
//     if (token.type === 'table_open') {  
//       currentTable = [];  
//       inTable = true;  
//     } else if (token.type === 'table_close') {  
//       inTable = false;  
//       const table = new Table({  
//         rows: currentTable.map(row => new TableRow({  
//           children: row.map(cell => new TableCell({  
//             children: [new Paragraph({  
//               children: [new TextRun(cell.replace(/\*\*/g, ''))],  
//               alignment: AlignmentType.LEFT,  
//               textDirection: 0, // 确保文字方向为水平  
//             })],  
//             width: {  
//               size: 150, // 调整单元格宽度  
//               type: WidthType.PX,  
//             },  
//             borders: {  
//               top: { style: BorderStyle.SINGLE, color: '000000', size: 1 },  
//               bottom: { style: BorderStyle.SINGLE, color: '000000', size: 1 },  
//               left: { style: BorderStyle.SINGLE, color: '000000', size: 1 },  
//               right: { style: BorderStyle.SINGLE, color: '000000', size: 1 },  
//             }  
//           }))  
//         })),  
//         width: {  
//           size: 800, // 设置表格总宽度  
//           type: WidthType.PX,  
//         },  
//         borders: {  
//           top: { style: BorderStyle.SINGLE, color: '000000', size: 1 },  
//           bottom: { style: BorderStyle.SINGLE, color: '000000', size: 1 },  
//           left: { style: BorderStyle.SINGLE, color: '000000', size: 1 },  
//           right: { style: BorderStyle.SINGLE, color: '000000', size: 1 },  
//         }  
//       });  
//       docElements.push(table);  
//       currentTable = null;  
//     } else if (inTable) {  
//       if (token.type === 'tr_open') {  
//         currentRow = [];  
//       } else if (token.type === 'td_open') {  
//         const content = [];  
//         let i = index + 1;  
//         while (tokens[i].type !== 'td_close') {  
//           if (tokens[i].type === 'inline') {  
//             content.push(tokens[i].content.replace(/\*\*/g, ''));  
//           }  
//           i++;  
//         }  
//         currentRow.push(content.join(' '));  
//       } else if (token.type === 'tr_close') {  
//         currentTable.push(currentRow);  
//       }  
//     } else if (token.type === 'inline') {  
//       const cleanContent = token.content.replace(/\*\*/g, '');  
//       if (cleanContent.trim()) {  
//         docElements.push(new Paragraph({  
//           children: [new TextRun(cleanContent)],  
//           alignment: AlignmentType.LEFT,  
//           textDirection: 0  
//         }));  
//       }  
//     }  
//   });  

//   const doc = new Document({  
//     sections: [{  
//       children: docElements,  
//     }]  
//   });  

//   Packer.toBlob(doc).then(blob => {  
//     const link = document.createElement('a');  
//     link.href = URL.createObjectURL(blob);  
//     link.download = 'exported.docx';  
//     link.click();  
//     URL.revokeObjectURL(link.href);  
//   });  
// }  
exportToDocx() {  
  const md = this.md;  
  const tokens = md.parse(this.source, {});  
  const docElements = [];  
  let currentTable = null;  
  let currentRow = [];  
  let inTable = false;  
  let inHeading = false;  

  tokens.forEach((token, index) => {  
    if (token.type === 'table_open') {  
      currentTable = [];  
      inTable = true;  
    } else if (token.type === 'table_close') {  
      inTable = false;  
      const table = new Table({  
        rows: currentTable.map(row => new TableRow({  
          children: row.map(cell => new TableCell({  
            children: [new Paragraph({  
              children: [new TextRun(cell.replace(/\*\*/g, ''))],  
              alignment: AlignmentType.LEFT,  
            })],  
            width: { size: 150, type: WidthType.PX },  
            borders: {  
              top: { style: BorderStyle.SINGLE, size: 1 },  
              bottom: { style: BorderStyle.SINGLE, size: 1 },  
              left: { style: BorderStyle.SINGLE, size: 1 },  
              right: { style: BorderStyle.SINGLE, size: 1 },  
            }  
          }))  
        })),  
        width: { size: 800, type: WidthType.PX },  
        borders: {  
          top: { style: BorderStyle.SINGLE, size: 1 },  
          bottom: { style: BorderStyle.SINGLE, size: 1 },  
          left: { style: BorderStyle.SINGLE, size: 1 },  
          right: { style: BorderStyle.SINGLE, size: 1 },  
        }  
      });  
      docElements.push(table);  
      currentTable = null;  
    } else if (inTable) {  
      if (token.type === 'tr_open') {  
        currentRow = [];  
      } else if (token.type === 'td_open') {  
        const content = [];  
        let i = index + 1;  
        while (tokens[i].type !== 'td_close') {  
          if (tokens[i].type === 'inline') {  
            content.push(tokens[i].content.replace(/\*\*/g, ''));  
          }  
          i++;  
        }  
        currentRow.push(content.join(' '));  
      } else if (token.type === 'tr_close') {  
        currentTable.push(currentRow);  
      }  
    }  
    else if (token.type === 'heading_open') {  
      const level = token.tag.match(/h([1-6])/)[1];  
      const headingText = tokens[index + 1].content;  
      
      docElements.push(new Paragraph({  
        children: [new TextRun({  
          text: headingText,  
          bold: true,  
          font: "黑体"  
        })],  
        heading: HeadingLevel[`HEADING_${level}`],  
        spacing: { after: 200 }  
      }));  
      inHeading = true; 
    }  
    else if (token.type === 'heading_close') {  
      inHeading = false; 
    }  
    else if (token.type === 'inline' && !inHeading) {  
      const content = token.content;  
      
      // 新增逻辑：按换行符分割内容
      const lines = content.split('\n');  
      lines.forEach((line, lineIndex) => {  
        if (line.trim() === '') return; // 忽略空行
        
        const textRuns = [];  
        let remainingText = line;  
        
        while (remainingText.includes('**')) {  
          const boldStart = remainingText.indexOf('**');  
          const beforeBold = remainingText.substring(0, boldStart);  
          
          if (beforeBold) {  
            textRuns.push(new TextRun(beforeBold));  
          }  
          
          const boldEnd = remainingText.indexOf('**', boldStart + 2);  
          const boldText = remainingText.substring(boldStart + 2, boldEnd);  
          
          textRuns.push(new TextRun({  
            text: boldText,  
            bold: true  
          }));  
          
          remainingText = remainingText.substring(boldEnd + 2);  
        }  
        
        if (remainingText) {  
          textRuns.push(new TextRun(remainingText));  
        }  
        
        // 处理列表项  
        if (token.parent?.type === 'list_item') {  
          docElements.push(new Paragraph({  
            children: [  
              new TextRun({  
                text: '• ',  
                bold: true  
              }),  
              ...textRuns  
            ],  
            indent: { left: 400 },  
            spacing: { line: 300 }  
          }));  
        }   
        // 普通段落：每个换行符生成独立段落  
        else if (textRuns.length > 0) {  
          docElements.push(new Paragraph({  
            children: textRuns,  
            spacing: { line: 300 }  
          }));  
        }  
      });  
    }  
    else if (token.type === 'paragraph_open' && tokens[index + 2].type === 'paragraph_close') {  
      docElements.push(new Paragraph({  
        children: [new TextRun('')],  
        spacing: { after: 100 }  
      }));  
    }  
  });  

  const doc = new Document({  
    styles: {  
      paragraphStyles: [  
        {  
          id: 'Heading1',  
          name: 'Heading 1',  
          basedOn: 'Normal',  
          run: {  
            size: 28, 
            bold: true,  
            font: "黑体"  
          },  
          paragraph: {  
            spacing: { after: 200 }  
          }  
        },  
        {  
          id: 'Heading2',  
          name: 'Heading 2',  
          basedOn: 'Normal',  
          run: {  
            size: 24, 
            bold: true,  
            font: "黑体"  
          },  
          paragraph: {  
            spacing: { after: 180 }  
          }  
        }  
      ]  
    },  
    sections: [{  
      children: docElements,  
    }]  
  });  

  Packer.toBlob(doc).then(blob => {  
    const link = document.createElement('a');  
    link.href = URL.createObjectURL(blob);  
    link.download = `${this.sanitize}.docx`;  
    link.click();  
    URL.revokeObjectURL(link.href);  
  });  
}  
  }
}

</script>

<style scoped>
.markdown-editor {
  width: 100%;
  height: 100vh;
  padding: 20px;
}

.editor-container {
  display: flex;
  gap: 20px;
  height: 90vh;
}

.editor-section,
.preview-section {
  flex: 1;
  width: 50%;
  height: 100%;
}

.editor-input {
  width: 100%;
  height: calc(100% - 40px);
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 4px;
  resize: none;
  font-family: "Courier New", monospace;
}

.preview-content {
  width: 100%;
  height: calc(100% - 40px);
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 4px;
  overflow-y: auto;
  text-align: left;
}

.preview-content :deep(h1),
.preview-content :deep(h2),
.preview-content :deep(h3) {
  margin: 1em 0;
  color: #333;
}

.preview-content :deep(p) {
  line-height: 1.6;
  margin: 1em 0;
}

.preview-content :deep(code) {
  background-color: #f6f8fa;
  padding: 2px 4px;
  border-radius: 4px;
  font-family: "Courier New", monospace;
}

.preview-content :deep(pre) {
  background-color: #f6f8fa;
  padding: 15px;
  border-radius: 6px;
  overflow-x: auto;
}

.preview-content :deep(blockquote) {
  border-left: 4px solid #ddd;
  padding-left: 1em;
  color: #666;
  margin: 1em 0;
}
</style>

<style scoped>
.markdown-editor {
  width: 100%;
  height: 100vh;
  padding: 20px;
}

.editor-container {
  display: flex;
  gap: 20px;
  height: 90vh;
}

.editor-section,
.preview-section {
  flex: 1;
  width: 50%;
  height: 100%;
}

.editor-input {
  width: 100%;
  height: calc(100% - 40px);
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 4px;
  resize: none;
  font-family: "Courier New", monospace;
}

.preview-content {
  width: 100%;
  height: calc(100% - 40px);
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 4px;
  overflow-y: auto;
  text-align: left;
}

.preview-content :deep(h1),
.preview-content :deep(h2),
.preview-content :deep(h3) {
  margin: 1em 0;
  color: #333;
}

.preview-content :deep(p) {
  line-height: 1.6;
  margin: 1em 0;
}

.preview-content :deep(code) {
  background-color: #f6f8fa;
  padding: 2px 4px;
  border-radius: 4px;
  font-family: "Courier New", monospace;
}

.preview-content :deep(pre) {
  background-color: #f6f8fa;
  padding: 15px;
  border-radius: 6px;
  overflow-x: auto;
}

.preview-content :deep(blockquote) {
  border-left: 4px solid #ddd;
  padding-left: 1em;
  color: #666;
  margin: 1em 0;
}
</style>
